<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='住宿管理' url='/cycle/stay/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">入住时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.staydate" type="month" placeholder="入住时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/cycle/stay/add" buttonname="住宿登记"></AddButton>
          <el-button type="primary" icon="el-icon-search" @click="RoomList()">房间视图</el-button>
          <!-- <el-button type="primary" icon="el-icon-search" @click="AddDetail()">生成住宿详细</el-button> -->
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="SpecName" label="专业">
            </el-table-column>
            <el-table-column label="住宿月份" width="200">
              <template slot-scope="scope">
                {{scope.row.StartDate|formatDate}} 至 {{scope.row.EndDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="MonthCount" label="累计住宿月份">
            </el-table-column>
            <el-table-column prop="MoneyCount" label="累计住宿费">
            </el-table-column>
            <el-table-column prop="RoomName" label="房间">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Print(scope.row)" type="text" size="medium" v-loading.fullscreen.lock="fullscreenLoading">住房记录</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import docxtemplater from 'docxtemplater'
  import JSZipUtils from 'jszip-utils'
  import saveAs from 'file-saver'
  import JSZip from 'jszip'
  export default {
    name: 'StayList',
    data() {
      return {
        condition: {
          stuname: '',
          stuno: '',
          stuspec: '',
          staydate: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        record: {
          StuName: '',
          StartDate: '',
          EndDate: '',
          RoomName: '',
          PrintDate: ''
        },
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordList',
        loading: true,
        fullscreenLoading: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StayEdit',
          params: {
            id: row.ID
          }
        })
      },
      RoomList:function(){
        this.$router.push({name: 'RoomRecordList'})
      },
      Delete: function(row) {
        var args = {
          id: row.ID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordDelete', args, row.StuName, this.$refs.btnSearch
          .Search)
      },
      CheckOut: function(row) {
        this.$confirm('确定执行 ' + row.StuName + ' 的退房操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            id: row.RecordID,
            token: this.condition.token
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APIRoom/CheckOut', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '退房成功',
                  type: 'success'
                })
                this.$refs.btnSearch.Search()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '退房失败',
                type: 'error'
              })
            })
        }).catch(() => {})
      },
      AddDetail: function() {
        var args = {
          token: this.condition.token
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordDetailAdd', args)
          .then(res => {
            console.log(res.data)
            if (res.data.Code === 0) {
              this.$message({
                message: '生成成功',
                type: 'success'
              })
              this.$refs.btnSearch.Search()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '生成失败',
              type: 'error'
            })
          })
      },
      Print: function(row) {
        var args = {
          id: row.ID,
          token: this.condition.token
        }
        this.fullscreenLoading = true
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIRoom/PrintRecord', args)
          .then(res => {
            if (res.data.Code === 0) {
              var info = JSON.parse(res.data.Data)
              that.record.StuName = info[0].StuName
              that.record.StartDate = info[0].StartDate
              that.record.EndDate = info[0].EndDate
              that.record.RoomName = info[0].RoomName
              that.record.PrintDate = info[0].PrintDate
              JSZipUtils.getBinaryContent("/staytemp.docx", function(error, content) {
                if (error) {
                  console.log(error.message)
                  that.$message({
                    message: '导出失败,' + error.message,
                    type: 'error'
                  })
                }

                let zip = new JSZip(content)
                let doc = new docxtemplater().loadZip(zip)
                console.log(that.tempdata)
                doc.setData({
                  ...that.record
                })
                try {
                  // 用模板变量的值替换所有模板变量
                  doc.render();
                } catch (error) {
                  console.log(error.message)
                  that.$message({
                    message: '导出失败,' + error.message,
                    type: 'error'
                  })
                }
                // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
                let out = doc.getZip().generate({
                  type: "blob",
                  mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });
                // 将目标文件对象保存为目标类型的文件，并命名
                saveAs(out, that.record.StuName + " 住宿介绍信.docx");
                that.noticeVisible = false
              })
            } else {
              this.$message({
                message: res.data.Data,
                type: 'error'
              })
            }
            this.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '导出失败',
              type: 'error'
            })
            this.fullscreenLoading = false
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
